<template>
	<div class="backup-banner" :class="{'remove-banner': closed}">
		
		<div class="msg-text">
			<span>{{$t('backup-banner.text')}}</span>
            <span> {{$t('backup-banner.version-text')}} {{ new Date(currentBackup.time ) | dateFormat('DD.MM.YYYY - HH:mm')}}</span>
		</div>

        <div class="actions">
            <button class="btn btn-secondary" @click="cancelRevertBackup">{{$t('backup-banner.cancel')}}</button>
            <button class="btn btn-primary"  @click="revertTemplate(currentBackup)">{{$t('backup-banner.revert')}}</button>
        </div>

	</div>

</template>

<script>
	import EventBus from "@/assets/js/eventBus.js";
	export default {
		data() {
			return {
                originalTemplateData: this.$store.state.originalTemplateData,
                template: this.$store.state.template,
                closed: false   
			}
        },
        methods:{
            cancelRevertBackup(){
                console.log(this.originalTemplateData)
                // this.$store.commit('setTemplateData', {template: this.originalTemplateData, variables: this.$store.state.templateVariables})
                this.$set(this.$store.state.template, 'sections', this.originalTemplateData.sections)
                this.$store.dispatch('getTemplatePreview', {
                        template: this.$store.state.template,
                        variables: this.$store.state.templateVariables,
                    }).then(preview => {
                        // this.$store.state.templatePreview = preview
                        this.$store.commit("setTemplatePreview", preview);
                        this.$store.state.originalTemplateData = null
                        this.closed = true
                        setTimeout( ()=> {this.$store.state.showingTemplateBackupInPreview = null}, 100)
                        EventBus.$emit('close_backup_preview')
                    }).catch(e =>{
                        console.log(e)
                });
            },

            revertTemplate(backup){
				console.log(backup)
				this.$store.dispatch("revertTemplate",{ templateId: this.$store.state.template.metadata.id, backupId: backup.id}).then(info => {
						console.log(info)
                        this.$store.dispatch("getTemplateData", this.$route.params.templateId)
                     
                        this.closed = true
                        setTimeout( ()=> {this.$store.state.showingTemplateBackupInPreview = null}, 100)
					}).catch(e =>{
						console.log(e)
					});
			},	
        },
        computed:{
            currentBackup(){
                return this.$store.state.showingTemplateBackupInPreview
            }
        },
        destroyed(){   
            this.$store.state.showingTemplateBackupInPreview = null
        }

    }

</script>

<style lang="less">
.backup-banner{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 55px;
    background: #3D464A;
    color: #fff;
    font-size: 14px;
    // font-weight: bold;
    z-index:2;
    animation: slideInFromTop .4s ease ;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
    -webkit-box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
    display: flex;
    align-items: center;
    padding:0 12px;
    justify-content: space-between;

     .msg-text{
         display: flex;
         flex-direction: column;
     }
     .actions{
         .btn{
             margin: 0 4px;
         }
         .btn-secondary{
             background-color: rgba(176, 179, 176, 0.144) !important;
              border-color: rgba(176, 179, 176, 0.144) !important;
            //   border: none !important;
            color: #fff !important;
         }
     }
    }
    .remove-banner{
        animation: slideOutTop .2s ease !important;
    }
    
    @keyframes slideOutTop {
	from{
		transform: translateY(0);
		opacity: 1;
	}
	to{
		transform: translateY(-200px);
		opacity: 0.6;
	}
}

    @keyframes slideInFromTop {
	from{
		transform: translateY(-300px);
		opacity: 0.6;
	}
	to{
		transform: translateY(0);
		opacity: 1;
	}
}


	
	
</style>

